"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextInputError = exports.StyledTextInput = exports.StyledInputContainer = exports.StyledInput = exports.StyledContainer = exports.StyledButton = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _Button = _interopRequireDefault(require("../Button/Button.index"));

var _TextInput = _interopRequireDefault(require("../TextInput/TextInput.index"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "TextInputButtonstyles__StyledContainer",
  componentId: "sc-htc7zu-0"
})(["", " ", " & > *{", "}"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    flex items-center ba bg-white \n  ", "\n  "])), function (_ref) {
  var _ref$theme$textInputB = _ref.theme.textInputButton,
      borderColor = _ref$theme$textInputB.borderColor,
      borderRadius = _ref$theme$textInputB.borderRadius;
  return "".concat(borderColor, " ").concat(borderRadius);
}), function (_ref2) {
  var borderWidth = _ref2.theme.textInputButton.borderWidth;
  return "border-width: ".concat(borderWidth, ";");
}, (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["nowrap"]))));

exports.StyledContainer = StyledContainer;

var StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "TextInputButtonstyles__StyledInput",
  componentId: "sc-htc7zu-1"
})(["", " outline:none;"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 bn\n  ", "\n  "])), function (_ref3) {
  var fontSize = _ref3.theme.textInputButton.fontSize;
  return fontSize;
}));

exports.StyledInput = StyledInput;

var StyledInputContainer = _styledComponents["default"].div.withConfig({
  displayName: "TextInputButtonstyles__StyledInputContainer",
  componentId: "sc-htc7zu-2"
})(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["w-100 ph2"]))));

exports.StyledInputContainer = StyledInputContainer;
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TextInputButtonstyles__StyledButton",
  componentId: "sc-htc7zu-3"
})(["", ""], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["ma2"]))));
exports.StyledButton = StyledButton;
var StyledTextInput = (0, _styledComponents["default"])(_TextInput["default"]).withConfig({
  displayName: "TextInputButtonstyles__StyledTextInput",
  componentId: "sc-htc7zu-4"
})(["&{border:1px solid red;border-width:0;& input[class*='StyledTextInputObject']{border-color:red;border-width:0;}}& [class*='StyledTextInputContainer']{", "}"], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["bn"]))));
exports.StyledTextInput = StyledTextInput;

var StyledTextInputError = _styledComponents["default"].div.withConfig({
  displayName: "TextInputButtonstyles__StyledTextInputError",
  componentId: "sc-htc7zu-5"
})(["", " font-size:", ""], (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["sans-serif w-100 pt1\n    ", "\n  "])), function (props) {
  return props.theme.textInput.errorColor;
}), function (props) {
  return props.theme.textInput.errorMessageFontSize || '0.875rem';
});

exports.StyledTextInputError = StyledTextInputError;